module.exports = __webpack_public_path__ + "static/img/ppjzzd.40a35766.png";